<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    fill: {
      type: String,
      default: 'none',
    },
    stroke: {
      type: String,
      default: '#123C55',
    },
    width: {
      type: [Number, String],
      default: '12',
    },
    height: {
      type: [Number, String],
      default: '22',
    },
  },
};
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 22"
    :class="`svg ${name}`"
  >
    <path
      :fill="fill"
      :stroke="stroke"
      d="M1 1l10 10L1 21"
    />
  </svg>
</template>
